import { render, staticRenderFns } from "./ApproverModal.vue?vue&type=template&id=51197d7b&"
import script from "./ApproverModal.vue?vue&type=script&lang=js&"
export * from "./ApproverModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports